import {
  CompletedIndicatedTakenMedicationsAnswer,
  CompletedIndicatedTakingMedicationsAnswer,
} from "~/common/utils/consultations/intake/interfaces";
import { formatDateFromBE } from "~/providers/utils";

export const formatCurrentMedicationCompletedAnswer = (
  answer?: CompletedIndicatedTakingMedicationsAnswer,
) =>
  answer?.medications_data?.map((answer) => {
    const { month, year } = formatDateFromBE(answer.date_started);

    return {
      how_did_it_work: answer.how_did_it_work,
      medication: answer.medication,
      year_started: year,
      month_started: month,
    };
  });

export const formatPastMedicationCompletedAnswer = (
  answer?: CompletedIndicatedTakenMedicationsAnswer,
) =>
  answer?.medications_data?.map((answer) => {
    const { month: monthStarted, year: yearStarted } = formatDateFromBE(
      answer.date_started,
    );
    const { month: monthStopped, year: yearStopped } = formatDateFromBE(
      answer.date_stopped,
    );

    return {
      how_did_it_work: answer.how_did_it_work,
      why_it_stopped: answer.why_it_stopped,
      medication: answer.medication,
      year_started: yearStarted,
      month_started: monthStarted,
      month_stopped: monthStopped,
      year_stopped: yearStopped,
    };
  });
